import api from './index';
import publicApi from './publicApi';
import config from '../config';

export const getCards = async () => {
  const response = await api.get('/analytics/portfolios');
  return response.data;
};

export const getCardAnalytics = async (cardId, days = 30) => {
  const response = await api.get(`/analytics/portfolio/${cardId}?days=${days}`);
  return response.data;
};

export const getAnalyticsHistory = async (cardId, options = {}) => {
    const {
        days = 30,
        page = 0,
        size = 25,
        actionFilter = 'all',
        search = ''
    } = options;
    
    const params = new URLSearchParams({
        days: days.toString(),
        page: page.toString(),
        size: size.toString(),
        action_filter: actionFilter,
        search: search
    });
    
    const response = await api.get(`/analytics/history/${cardId}?${params}`);
    return response.data;
};

export const trackCardView = async (cardSlug) => {
  console.log(`\n🚀 FRONTEND: trackCardView() CALLED! 🚀`);
    console.log(`📂 Card Slug: ${cardSlug}`);
    console.log(`🕐 Timestamp: ${new Date().toISOString()}`);
    console.log(`🌐 Current URL: ${window.location.href}`);
    console.log(`📡 API Base URL: ${config.apiBaseUrl}`);
    
    try {
        console.log(`🔄 Attempting primary tracking method...`);
        console.log(`🎯 API Endpoint: /analytics/track/view/${cardSlug}`);
        
        const response = await publicApi.post(`/analytics/track/view/${cardSlug}`);
        
        console.log(`✅ PRIMARY TRACKING SUCCESS!`);
        console.log(`📊 Response Status: ${response.status}`);
        console.log(`📋 Response Data:`, response.data);
        console.log(`🎉 Card view tracked successfully for: ${cardSlug}`);
        
        return true;
    } catch (error) {
        console.log(`❌ PRIMARY TRACKING FAILED!`);
        console.log(`🔴 Error Details:`, error);
        console.log(`📡 Response Status: ${error.response?.status}`);
        console.log(`💬 Response Message: ${error.response?.data}`);
        console.log(`⚠️  Error Message: ${error.message}`);
        
        // Try alternative tracking method
        try {
            console.log(`🔄 Attempting FALLBACK tracking method...`);
            const fallbackUrl = `${config.apiBaseUrl}/analytics/track/view/${cardSlug}`;
            console.log(`🎯 Fallback URL: ${fallbackUrl}`);
            
            const fallbackResponse = await fetch(fallbackUrl, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'User-Agent': navigator.userAgent || 'Unknown'
                },
                body: JSON.stringify({})
            });
            
            console.log(`📡 Fallback Response Status: ${fallbackResponse.status}`);
            
            if (fallbackResponse.ok) {
                const fallbackData = await fallbackResponse.json();
                console.log(`✅ FALLBACK TRACKING SUCCESS!`);
                console.log(`📋 Fallback Response Data:`, fallbackData);
                console.log(`🎉 Card view tracked via fallback method for: ${cardSlug}`);
                return true;
            } else {
                console.log(`❌ Fallback also failed with status: ${fallbackResponse.status}`);
                const errorText = await fallbackResponse.text();
                console.log(`💬 Fallback Error Text: ${errorText}`);
                return false;
            }
        } catch (fallbackError) {
            console.log(`💥 BOTH TRACKING METHODS FAILED!`);
            console.log(`🔴 Fallback Error:`, fallbackError);
            console.log(`❌ Complete failure to track card view for: ${cardSlug}`);
            return false;
        }
    }
};

export const trackCardInteraction = async (cardSlug, interactionType, interactionValue = null) => {
  try {
    console.log(`🎯 Tracking interaction: ${interactionType}=${interactionValue} for ${cardSlug}`);
    const response = await publicApi.post(`/analytics/track/interaction/${cardSlug}`, {
      interaction_type: interactionType,
      interaction_value: interactionValue
    });
    console.log('✅ Card interaction tracked successfully:', response.data);
        return true;
    } catch (error) {
        console.error('❌ Failed to track card interaction:', error.response?.data || error.message);
        // Try alternative tracking method
        try {
            await fetch(`${config.apiBaseUrl}/analytics/track/interaction/${cardSlug}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    interaction_type: interactionType,
                    interaction_value: interactionValue
                })
            });
            console.log('✅ Card interaction tracked via fallback method');
            return true;
        } catch (fallbackError) {
            console.error('❌ Fallback interaction tracking also failed:', fallbackError);
            return false;
        }
    }
};

export const trackCardShare = async (cardSlug, shareType) => {
  console.log(`\n🚀 FRONTEND: trackCardShare() CALLED! 🚀`);
    console.log(`📂 Card Slug: ${cardSlug}`);
    console.log(`📤 Share Type: ${shareType}`);
    console.log(`🕐 Timestamp: ${new Date().toISOString()}`);
    console.log(`🌐 Current URL: ${window.location.href}`);
    
    try {
        console.log(`🔄 Attempting primary share tracking method...`);
        console.log(`🎯 API Endpoint: /analytics/track/share/${cardSlug}`);
        
        const response = await publicApi.post(`/analytics/track/share/${cardSlug}`, {
            share_type: shareType
        });
        
        console.log(`✅ PRIMARY SHARE TRACKING SUCCESS!`);
        console.log(`📊 Response Status: ${response.status}`);
        console.log(`📋 Response Data:`, response.data);
        console.log(`🎉 Card share tracked successfully for: ${cardSlug}`);
        
        return true;
    } catch (error) {
        console.log(`❌ PRIMARY SHARE TRACKING FAILED!`);
        console.log(`🔴 Error Details:`, error);
        console.log(`📡 Response Status: ${error.response?.status}`);
        console.log(`💬 Response Message: ${error.response?.data}`);
        console.log(`⚠️  Error Message: ${error.message}`);
        
        // Try alternative tracking method
        try {
            console.log(`🔄 Attempting FALLBACK share tracking method...`);
            const fallbackUrl = `${config.apiBaseUrl}/analytics/track/share/${cardSlug}`;
            console.log(`🎯 Fallback URL: ${fallbackUrl}`);
            
            const fallbackResponse = await fetch(fallbackUrl, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'User-Agent': navigator.userAgent || 'Unknown'
                },
                body: JSON.stringify({
                    share_type: shareType
                })
            });
            
            console.log(`📡 Fallback Response Status: ${fallbackResponse.status}`);
            
            if (fallbackResponse.ok) {
                const fallbackData = await fallbackResponse.json();
                console.log(`✅ FALLBACK SHARE TRACKING SUCCESS!`);
                console.log(`📋 Fallback Response Data:`, fallbackData);
                console.log(`🎉 Card share tracked via fallback method for: ${cardSlug}`);
                return true;
            } else {
                console.log(`❌ Fallback also failed with status: ${fallbackResponse.status}`);
                const errorText = await fallbackResponse.text();
                console.log(`💬 Fallback Error Text: ${errorText}`);
                return false;
            }
        } catch (fallbackError) {
            console.log(`💥 BOTH SHARE TRACKING METHODS FAILED!`);
            console.log(`🔴 Fallback Error:`, fallbackError);
            console.log(`❌ Complete failure to track card share for: ${cardSlug}`);
            return false;
        }
    }
};

// Admin-only analytics endpoints
export const getAllUsers = async () => {
  const response = await api.get('/analytics/admin/users');
  return response.data;
};

export const getUserCards = async (userId) => {
  const response = await api.get(`/analytics/admin/user/${userId}/portfolios`);
  return response.data;
};

export const getAllUsersAnalytics = async (days = 30) => {
  const response = await api.get(`/analytics/admin/analytics/all-users?days=${days}`);
  return response.data;
};

export const getUserAnalytics = async (userId, days = 30) => {
  const response = await api.get(`/analytics/admin/analytics/user/${userId}?days=${days}`);
  return response.data;
}; 